import React from 'react';
import styled from 'styled-components';
import {COLORS, ELEVATIONS, SIZES, Typography} from '@fupa/fupa-uikit';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: ${SIZES['64']};
  background-color: ${COLORS.fupaPrimary};
  box-sizing: content-box;
  box-shadow: ${ELEVATIONS.AppBar};
`;

const StyledTypography = styled(Typography)`
  &&& {
    color: ${COLORS.white};
  }
`;

const AppBar = () => {
  return (
    <Wrapper>
      <StyledTypography variant='headline' component='h1'>
        Interwetten Elf des Jahres
      </StyledTypography>
    </Wrapper>
  );
};

export {AppBar};
